import useFacetFiltering from '@sls-react/contexts/facetFiltering/useFacetFiltering';
import fireAnalytics from '@sls-react/services/analytics/fireAnalytics';
import Cookies from 'js-cookie';
import { KnownCookie } from '@sls-react/typings/cookies';
import fireGAEvent from '@sls-react/services/analytics/fireGAEvent';
import { AbTestBucket } from '@sls-react/api/abTest';

export function fireVisitedResults({
  facetFiltering: {
    category,
    filterCount,
    filterState,
    lander,
    facets,
    paging,
    similarToItem,
  },
}: {
  facetFiltering: ReturnType<typeof useFacetFiltering>;
}) {
  let params: any = {};

  params.fast_shipping = Cookies.get(
    'fast_shipping_filter_enabled' as KnownCookie,
  )
    ? '1'
    : '0';

  params.filters = filterCount;

  if (category) {
    const [primarySlug, secondarySlug, thirdSlug] = category.slug.split('/');

    params.category = category.slug;

    if (primarySlug) {
      params.category_1 = primarySlug;
    }

    if (secondarySlug) {
      params.category_2 = secondarySlug;
    }

    if (thirdSlug) {
      params.category_3 = thirdSlug;
    }
  }

  if (paging) {
    params.results = paging.total_count;
    params.page = paging.page;
  }

  params.url = window.location.pathname + window.location.search;

  // Add condition and brand
  if (filterState) {
    params.query = filterState;

    if (filterState.brand) {
      // If there's only 1, send just the brand.
      // If there's more than 1, send the count (as a string)
      if (filterState.brand.length === 1) {
        params.brand = filterState.brand[0];
      } else {
        params.brand = String(filterState.brand.length);
      }
    }

    if (filterState.condition) {
      params.condition = filterState.condition.sort().join(',');
    }

    if (filterState.q) {
      params.q = filterState.q;
    }

    if (filterState.sort) {
      params.sort = filterState.sort;
    }

    if (filterState.recently_sold) {
      params.state_sold = 1;
    }

    if (filterState.price_drop) {
      params.price_drop = 1;
    }

    // 1 or 0 for saved search
    params.saved_search = +!!filterState.saved_search_id;
  }

  if (lander) {
    params.lander_slug = lander.slug;
  }

  if (lander) {
    params.depth = lander.path?.split('/').length ?? 0;
  }

  if (lander) {
    if (lander.model) {
      params = {
        ...params,
        mode: 'model',
        model_name: lander.model?.name,
      };
    } else if (similarToItem) {
      params = {
        ...params,
        price: similarToItem.list_price,
        item_id: similarToItem.id,
        name: similarToItem.name,
        mode: 'pla',
      };
    } else {
      params.mode = 'shop';
    }
  } else {
    params.mode = 'search';
  }

  fireAnalytics('Visited Results', null, params);

  fireGAEvent('send', 'event', params.category, 'Visited Results', {
    nonInteraction: true,
  });
}

interface FireAppliedFilterParams {
  detail: string;
  detail_name: string;
  detail_value_name?: string;
}

export function fireAppliedFilter({
  detail,
  detail_name,
  detail_value_name,
}: FireAppliedFilterParams) {
  fireAnalytics('Applied Filter', null, {
    detail,
    detail_name,
    detail_value_name,
  });
}

export function fireAppliedFastShipping(zip: string) {
  fireAppliedFilter({
    detail: 'fast_shipping',
    detail_name: 'Delivery',
    detail_value_name: zip,
  });
}

export function fireAppliedCanadianSeller(enabled: boolean) {
  fireAppliedFilter({
    detail: 'canadian_seller_only',
    detail_name: 'Delivery',
    detail_value_name: enabled ? 'true' : 'false',
  });
}

export function fireViewedFilters() {
  fireAnalytics('Visited Filters');
}
